import { render, staticRenderFns } from "./p-edit-permissions-popup.vue?vue&type=template&id=07695d66&scoped=true"
import script from "./p-edit-permissions-popup.vue?vue&type=script&lang=js"
export * from "./p-edit-permissions-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07695d66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07695d66')) {
      api.createRecord('07695d66', component.options)
    } else {
      api.reload('07695d66', component.options)
    }
    module.hot.accept("./p-edit-permissions-popup.vue?vue&type=template&id=07695d66&scoped=true", function () {
      api.rerender('07695d66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mpermissions/views/popups/p-edit-permissions-popup.vue"
export default component.exports